import { useTranslation } from 'react-i18next';

import { type PrizeNameProps } from './types';

import s from './index.module.scss';

export const BoosterXPPrizeName = ({ prize }: PrizeNameProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={s.name}>{t('×2 XP Booster', { value: prize.amount })}</div>
      <div className={s.description}>
        {t('Any XP you earn in the next 20 minutes will be multiplied by 2.', {
          duration: prize.duration?.replace(/\D/g, ''),
          boosterValue: prize.amount,
        })}
      </div>
    </>
  );
};
